var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-named-as-default-member */
import axios from 'axios';
import CartUtil from './cartUtil';
let SamplesInCartState = [];
const getSamplesInCart = () => __awaiter(void 0, void 0, void 0, function* () {
    const samplesInCart = yield CartUtil.get().then((result) => {
        const { items } = result;
        SamplesInCartState = items.filter((lineItem) => {
            return lineItem.product_type === 'First Tier Sample' || lineItem.product_type === 'Second Tier Sample';
        });
        return SamplesInCartState;
    });
    return samplesInCart;
});
// Get all the products added to the complimentary samples collection
const getSampleProducts = (collection) => {
    return axios.get(`/collections/${collection}?view=json-data`).then((res) => __awaiter(void 0, void 0, void 0, function* () {
        const inCart = yield getSamplesInCart();
        return res.data.products.map((item) => {
            const newItem = item;
            newItem.inCart = !!inCart.find((elem) => {
                return elem.variant_id === item.variants[0].id;
            });
            return newItem;
        });
    }));
};
const getFirstTierSamples = (cartSamples) => {
    return cartSamples.filter((sample) => {
        return sample.product_type === 'First Tier Sample';
    });
};
const getSecondTierSamples = (cartSamples) => {
    return cartSamples.filter((sample) => {
        return sample.product_type === 'Second Tier Sample';
    });
};
const addSample = (item, firstTierThreshold, secondTierThreshold) => __awaiter(void 0, void 0, void 0, function* () {
    // Get all samples in the cart
    const samplesInCart = yield getSamplesInCart();
    // If there are already two samples in that tier, don't do anything
    const firstTierSamples = getFirstTierSamples(samplesInCart);
    const secondTierSamples = getSecondTierSamples(samplesInCart);
    if ((item.type === 'First Tier Sample' && firstTierSamples.length === firstTierThreshold) || (item.type === 'Second Tier Sample' && secondTierSamples.length === secondTierThreshold)) {
        return null;
    }
    // Add this sample
    const items = [];
    items.push(item);
    const added = yield CartUtil.add(items);
    return added;
});
const removeSample = (itemID) => __awaiter(void 0, void 0, void 0, function* () {
    const deleteObj = {
        [itemID]: 0,
    };
    const updated = yield CartUtil.update(deleteObj);
    return updated;
});
const validateSamplesInCart = (firstThreshold, secondThreshold, cartTotal) => __awaiter(void 0, void 0, void 0, function* () {
    // Get current cart samples
    const samplesInCart = yield getSamplesInCart();
    let firstTierSamples = [];
    let secondTierSamples = [];
    let allSamplesInCart = [];
    // Get samples from both tiers
    if (samplesInCart.length > 0) {
        firstTierSamples = yield getFirstTierSamples(samplesInCart);
        secondTierSamples = yield getSecondTierSamples(samplesInCart);
        allSamplesInCart = samplesInCart.map((innerSample) => {
            return innerSample.product_id;
        });
    }
    // Remove samples from a tier if no longer at threshold
    if (cartTotal < firstThreshold && samplesInCart.length > 0) {
        // remove all samples
        const toDelete = {};
        samplesInCart.forEach((sample) => (toDelete[sample.variant_id] = 0));
        yield CartUtil.update(toDelete).then(() => {
            // TODO Change to ajax
            //window.location.reload();
        });
        firstTierSamples = [];
        secondTierSamples = [];
        allSamplesInCart = [];
    }
    else if (cartTotal < secondThreshold && secondTierSamples.length > 0) {
        // remove second tier samples
        const toDelete = {};
        secondTierSamples.forEach((sample) => (toDelete[sample.variant_id] = 0));
        yield CartUtil.update(toDelete).then(() => {
            // TODO Change to ajax
            //window.location.reload();
        });
        secondTierSamples = [];
        allSamplesInCart = firstTierSamples.map((innerSample) => {
            return innerSample.product_id;
        });
    }
    return {
        first: firstTierSamples,
        second: secondTierSamples,
        all: allSamplesInCart,
    };
});
export default {
    getSampleProducts,
    addSample,
    validateSamplesInCart,
    removeSample,
};
